import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            Browse Product Categories
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            Explore our comprehensive product catalog — click any category to shop on BaseTao Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative flex flex-col bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 hover:shadow-sm transition-all cursor-pointer"
            >
              {/* Product Image */}
              <div className="relative h-32 sm:h-36 md:h-40 overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                {/* Subtle gradient overlay for text readability */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                {/* Icon badge */}
                <span className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center rounded-lg bg-background-50/90 backdrop-blur-sm text-primary-500 shadow-sm">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
              </div>

              {/* Category Name */}
              <div className="p-3 md:p-3.5">
                <span className="text-xs md:text-sm font-semibold text-foreground-800 text-center block group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}